import { render, staticRenderFns } from "./FoodGraph1D.vue?vue&type=template&id=01b04623&scoped=true&"
import script from "./FoodGraph1D.vue?vue&type=script&lang=js&"
export * from "./FoodGraph1D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b04623",
  null
  
)

export default component.exports